import { useTw } from '../../../../../../../../../utils/Styles'
import {
  CheckIcon,
  ClockIcon,
  FireIcon,
  LightBulbIcon,
} from '@heroicons/react/solid'

export function TimelineEntryIcons({ status }: { status: string }) {
  const tw = useTw()

  switch (status) {
    case 'RESOLVED':
      return (
        <span
          className={tw`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-blue-500`}
        >
          <CheckIcon className={tw`h-5 w-5 text-white`} aria-hidden="true" />
        </span>
      )

    case 'MONITORING':
      return (
        <span
          className={tw`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-green-500`}
        >
          <ClockIcon className={tw`h-5 w-5 text-white`} aria-hidden="true" />
        </span>
      )

    case 'IDENTIFIED':
      return (
        <span
          className={tw`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-yellow-500`}
        >
          <LightBulbIcon
            className={tw`h-5 w-5 text-white`}
            aria-hidden="true"
          />
        </span>
      )

    case 'ONGOING':
      return (
        <span
          className={tw`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-red-500`}
        >
          <FireIcon className={tw`h-5 w-5 text-white`} aria-hidden="true" />
        </span>
      )

    default:
      return null
  }
}
